export default __webpack_public_path__ + "static/media/dashboard-blue.3bd9ab86.svg";